import Post from 'app/utils/Post';
import {inject, observer} from 'mobx-react';
import React, {Component, MouseEvent, ReactNode} from 'react';
import I18n from 'app/i18n';
import {userSignedIn, isGuest, slowConnectionPromise} from 'app/utils';
import {ActiveSurveyStore} from 'app/store/ActiveSurveyStore';
import {langsValue} from 'app/utils/langs/langsValue';
import {SignInButton} from 'app/components/auth/SignInButton';
import AsideItem from 'site_version/com/AsideItem';

interface SurveyStatisticsProps {
    activeSurveyStore?: ActiveSurveyStore
    headingClick?: boolean
}

interface SurveyStatisticsStates {
    disabled: boolean
    results: boolean
    currentAnswer: number
}

@inject('activeSurveyStore')
@observer
export default class SurveyStatistics extends Component<SurveyStatisticsProps, SurveyStatisticsStates> {
    state = {
        currentAnswer: null,
        disabled: true,
        results: false
    };

    container = React.createRef();

    toggleResults = (value?: boolean): void => {
        this.setState(prevState => ({
            disabled: true,
            results: typeof value === 'boolean' ? value : !prevState.results
        }));
    };

    handleToggleResults = (e: MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        this.setState({
            disabled: true,
            results: !this.state.results
        });
    };

    radioClick = (): void => {
        this.setState({disabled: false});
    };

    saveAnswer = (e: MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        const {currentAnswer} = this.state;

        if (!currentAnswer) {
            return;
        }

        slowConnectionPromise(
            new Post({
                params: {id: this.state.currentAnswer},
                url: '/surveys'
            })
                .execute()
                .then(data => data.json())
                .then(data => {
                    this.props.activeSurveyStore.updateElementCollection(data);
                    this.toggleResults(true);
                })
        );
    };

    handleDisable = (): void => this.setState({disabled: false});

    handleAnswerChoosing = (e: React.ChangeEvent<HTMLInputElement>): void => this.setState({currentAnswer: Number(e.target.value)});

    header = (): ReactNode => <>
        <div className="aside-item-heading__title">
            <h3>{I18n.t('survey')}</h3>
        </div>
    </>;

    render(): ReactNode {
        const {record: activeSurvey} = this.props.activeSurveyStore;

        if (!activeSurvey || Object.keys(activeSurvey).length === 0) {
            return null;
        }

        const {user_answer_id} = activeSurvey;
        const answered = user_answer_id > 0;
        const {disabled, results} = this.state;

        return <AsideItem
            header={this.header()}
            name="survey-statistics-name"
            itemClassName="survey-statistics"
            headingClick={this.props.headingClick}
        >
            <div className="survey-content">
                <span className="survey-question">{langsValue(activeSurvey, 'question')}</span>
                {!results && !answered
                    ? <ul className="survey-answers-list" key="answers">
                        {activeSurvey.answers.map(a => <li className="survey-answer" key={a.id}>
                            <label className="field__radio" onClick={this.handleDisable}>
                                <input
                                    type="radio"
                                    name="voting"
                                    onChange={this.handleAnswerChoosing}
                                    value={a.id}
                                />
                                <div className="field__radio-box"/>
                                <div className="field__radio-label">{langsValue(a, 'answer')}</div>
                            </label>
                        </li>)}
                    </ul>
                    : <ul className={`survey-results-list${answered ? ' answered' : ''}`} key="results">
                        {activeSurvey.answers.map(a => <li
                            className={`survey-result${a.id === user_answer_id ? ' survey-result--selected' : ''}`}
                            key={a.id}
                        >
                            <div className="survey-result-label">{langsValue(a, 'answer')}</div>
                            <div className="survey-result-count">{a.percent}%</div>
                            <div className="survey-result-progress">
                                <span style={{width: `${a.percent}%`}}/>
                            </div>
                        </li>)}
                    </ul>}
                {!answered && <div className="wrapper-survey-more">
                    <button className="button-survey-more" onClick={this.handleToggleResults}>
                        {I18n.t(results ? 'hide_results' : 'show_results')}
                    </button>
                </div>}

                {userSignedIn() && !answered &&
                    <button
                        className={`button-adaptive${disabled ? ' button-adaptive_disable' : ''}`}
                        disabled={disabled}
                        onClick={this.saveAnswer}
                    >
                        {I18n.t('vote')}
                    </button>}
                {isGuest() && <SignInButton title={I18n.t('vote')} usingOnTab={'SURVEY_RIGHT_BLOCK'}/>}
            </div>
        </AsideItem>;
    }
}
